import type {CSSProperties} from "react"
import {cn} from "@/lib/utils"

const GRID_COLS = 4
const WAVE_MS = 800

export function AskDotgridIcon({
  size = 26,
  auto = false,
  className,
}: {
  size?: number
  auto?: boolean
  className?: string
}) {
  const inset = size * 0.16
  const span = size - inset * 2
  const step = span / (GRID_COLS - 1)
  const r = Math.max(0.6, size * 0.06)
  const dots = []
  for (let row = 0; row < GRID_COLS; row++) {
    for (let col = 0; col < GRID_COLS; col++) {
      const cx = inset + col * step
      const cy = inset + row * step
      const delay = Math.round((col / (GRID_COLS - 1)) * WAVE_MS)
      dots.push(
        <circle
          key={row * GRID_COLS + col}
          cx={cx}
          cy={cy}
          r={r}
          style={{"--ask-d": `${delay}ms`} as CSSProperties}
        />,
      )
    }
  }

  return (
    <svg
      aria-hidden
      className={cn("ask-dotgrid shrink-0 overflow-visible", auto && "ask-dotgrid--auto", className)}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
      style={{transform: "rotate(45deg)", transformOrigin: "center"}}
    >
      {dots}
    </svg>
  )
}
